import { useRef } from 'react';

import { SimpleAlert } from '#/common/components';
import { useChatbotMessages } from './useChatbotMessages';
import { useChatbotPreview } from './useChatbotPreview';
import { useLeadForm } from './useLeadForm';
import { useResponsiveLayout } from './useResponsiveLayout';

function useChatbotWidget() {
  const alert = SimpleAlert.useAlert();
  const inputRef = useRef(null);
  const {
    chatbotData,
    messages,
    isSending,
    isStreaming,
    streamingMessage,
    updateMessages,
    handleReaction,
    contentRef,
    faqContainerRef,
    additionalNoteRef,
    streamingMessageRef,
    reactions,
    faqQuestionId,
    setFaqQuestionId,
    isFetching,
    isPending,
    chatbotDefaultPosition,
    faqExpanded,
    handleFaqStateChange,
    setMessages,
    onResetChat,
    onResetChatAsync,
    onResetChatLoading,
    isConversationHistoryFetching,
  } = useChatbotMessages({
    onMessageSendErrorHandler: message => alert.error(message),
    onMessageSendSuccessHandler: message => alert.success(message),
  });

  const {
    uploadedFiles,
    setUploadedFiles,
    isFieldSubmit,
    setIsFieldSubmit,
    leadFormik,
    isUploadFileLoading,
    handleFileChange,
    handleTelInputChange,
    handleLeadFormClose,
    handleSelectChange,
    renderLeadForm,
    isProcessingFiles,
    handleRemoveFile,
    fileRef,
    isLeadSubmitLoading,
    isSubmissionSuccess,
  } = useLeadForm(chatbotData, faqQuestionId, setFaqQuestionId, alert);

  const { handlePreviewToggle, inputField, handleChange, submitForm, handleEnterKeyPress } = useChatbotPreview(
    updateMessages,
    setFaqQuestionId,
    contentRef,
    isFieldSubmit,
    setIsFieldSubmit,
    setUploadedFiles,
    isStreaming,
    isSending,
    inputRef
  );

  const { isResponsive } = useResponsiveLayout(
    faqQuestionId,
    faqExpanded,
    contentRef,
    faqContainerRef,
    additionalNoteRef
  );

  return {
    alert,
    chatbotData,
    handlePreviewToggle,
    messages,
    isSending,
    isStreaming,
    streamingMessage,
    faqQuestionId,
    uploadedFiles,
    isFieldSubmit,
    contentRef,
    faqContainerRef,
    additionalNoteRef,
    streamingMessageRef,
    inputField,
    leadFormik,
    isUploadFileLoading,
    reactions,
    renderLeadForm,
    updateMessages,
    handleChange,
    handleEnterKeyPress,
    submitForm,
    handleReaction,
    handleFileChange,
    handleTelInputChange,
    handleLeadFormClose,
    isResponsive,
    handleSelectChange,
    isProcessingFiles,
    handleRemoveFile,
    fileRef,
    isLeadSubmitLoading,
    isSubmissionSuccess,
    isFetching,
    isPending,
    chatbotDefaultPosition,
    handleFaqStateChange,
    setMessages,
    onResetChat,
    onResetChatAsync,
    onResetChatLoading,
    isConversationHistoryFetching,
    inputRef,
  };
}

export default useChatbotWidget;
